<!-- 模板的弹出框 -->
<template>
  <div class="TemplatePop">
    <div
      class="createBooking"
      :style="FrameProperty"
    >
      <!-- 头部标题 -->
      <div class="EventWrapTtile">
        <div v-if="this.EventMotionSelect == 0">
          <!-- <p class="event_color" :class="selColor.name"></p> -->
          <p class="Event_title">{{ eventDetail.title }}</p>
        </div>
        <ul
          class="CompileTitle"
          v-else
        >
          <li
            @click="CompileType = 'note'"
            :class="{ active: CompileType === 'note' }"
          >
            {{ $t("lang.note") }}
          </li>
          <li class="separator">|</li>
          <li
            @click="CompileType = 'device'"
            :class="{ active: CompileType === 'device' }"
          >
            {{ $t("lang.device") }}
          </li>
        </ul>
        <div
          class="iconfont closeCreateBox"
          @click="AllOperation('closeBooking')"
        >
          &#xe603;
        </div>
      </div>
      <!-- 视频的详情 -->
      <div
        class="EventDetail"
        v-if="EventMotionSelect == 0"
      >
        <div class="detail_item">
          <p class="detailLeft">{{ $t("lang.time") }}</p>
          <p class="detailRight">{{ eventDetail.time }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t("lang.reporter") }}</p>
          <p class="detailRight">{{ eventDetail.reporter }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t("lang.storySlug") }}</p>
          <p class="detailRight">{{ eventDetail.description }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t("lang.deviceSourceScte") }}</p>
          <p class="detailRight">{{ eventDetail.source }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t("lang.bookingChannel") }}</p>
          <p class="detailRight">{{ eventDetail.rname }}</p>
        </div>
        <!-- <div class="detail_item">
          <p class="detailLeft">Secondary Record</p>
          <p class="detailRight">
            {{ eventDetail.record == 1 ? "Enable" : "Disable" }}
          </p>
        </div> -->
      </div>
      <!-- 创建与修改事件 -->
      <div
        class="EventUpdateandCreate"
        v-else
      >
        <div
          class="note"
          v-if="CompileType === 'note'"
        >
          <div class="c_item">
            <input
              type="text"
              maxlength="32"
              v-model="eventDetail.title"
              :placeholder="$t('lang.createTitle')"
            />
            <div
              class="color_box"
              @click="mostSwitch.ColorShow = !mostSwitch.ColorShow"
            >
              <div :class="['color', ColorTransition(eventDetail.color)]"></div>
              <i :class="['el-icon-caret-bottom', { top: mostSwitch.ColorShow }]"></i>
              <div
                class="color_opt"
                v-if="mostSwitch.ColorShow"
              >
                <span>{{ $t("lang.color") }}</span>
                <ul>
                  <li
                    v-for="(item, index) in colorArr"
                    :key="index"
                    :class="[item.name]"
                    @click.stop="chooseColor(item)"
                  ></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="c_item">
            <el-time-picker
              is-range
              v-model="TimeSelect"
              range-separator="to"
              :start-placeholder="$t('lang.enterStartTime')"
              :end-placeholder="$t('lang.enterEndTime')"
              @change="UpdateTime"
            >
            </el-time-picker>
          </div>
          <div class="c_item">
            <input
              type="text"
              class="reporter"
              maxlength="32"
              :placeholder="$t('lang.reporter')"
              v-model="eventDetail.reporter"
            />
          </div>
          <!-- <div class="c_item">
            <el-checkbox v-model="eventDetail.record"
              >Secondary Record</el-checkbox
            >
          </div> -->
          <div class="c_item des">
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              maxlength="255"
              :placeholder="$t('lang.des')"
              v-model="eventDetail.description"
            ></textarea>
          </div>
        </div>
        <div
          class="device"
          v-else
        >
          <div class="d_item source">
            <span>{{ $t("lang.bookingChannel") }}</span>
            <span class="val">{{ fixedDevice.name }}</span>
          </div>
          <div class="d_item pr">
            <span>{{ $t("lang.deviceSourceScte") }}</span>
            <span
              :class="[
                'val',
                'ValSelet',
                {
                  up: mostSwitch.BoxSourceList,
                },
              ]"
              @click="mostSwitch.BoxSourceList = !mostSwitch.BoxSourceList"
            >
              <span>{{ eventDetail.tname }}</span>
              <div
                class="createbox_r_list"
                :class="{ show_height: mostSwitch.showHeight }"
                v-if="mostSwitch.BoxSourceList"
              >
                <ul
                  class="infinite-list"
                  v-infinite-scroll="getSourceList"
                  style="overflow: auto"
                >
                  <li
                    v-for="(item, index) in SourceList"
                    :key="index"
                    class="infinite-list-item"
                    @click="SelectSource(item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </span>
          </div>
          <div class="d_item">
            <span>{{ $t("lang.delay") }}(0.5-50s)</span>
            <input
              type="text"
              :class="['input', { delay: mostSwitch.editDelay }]"
              maxlength="32"
              v-model="eventDetail.delay"
              @focus="mostSwitch.editDelay = true"
              @blur="mostSwitch.editDelay = false"
            />
          </div>
          <div class="d_item">
            <span>{{ $t("lang.bit") }}(100-1024Kbps)</span>
            <input
              type="text"
              maxlength="32"
              :class="['input', { bitrate: mostSwitch.editBit }]"
              v-model="eventDetail.bitrate"
              @focus="mostSwitch.editBit = true"
              @blur="mostSwitch.editBit = false"
            />
          </div>
        </div>
      </div>

      <!-- 底下的操作 -->
      <div class="create_footer">
        <div
          class="DetailButton"
          v-show="EventMotionSelect == 0"
        >
          <button
            class="delete"
            @click="AllOperation('deleteBooking')"
          >
            {{ $t("lang.delete") }}
          </button>
          <button
            class="copy"
            @click="EventMotionSelect = 2"
          >
            {{ $t("lang.copy") }}
          </button>
          <button
            class="edit"
            @click="EventMotionSelect = 1"
          >
            {{ $t("lang.edit") }}
          </button>
        </div>
        <div
          class="ComplieButton"
          v-show="EventMotionSelect != 0"
        >
          <button
            class="cancel"
            @click="AllOperation('closeBooking')"
          >
            {{ $t("lang.cancel") }}
          </button>
          <button
            class="save f_right"
            v-show="EventMotionSelect == 1"
            @click="AllOperation('saveBooking')"
          >
            {{ $t("lang.save") }}
          </button>
          <button
            class="save"
            v-show="EventMotionSelect == 2"
            @click="AllOperation('createBooking')"
          >
            {{ $t("lang.create") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    // 查询模板的信息
    TemplateBodyMessage: {
      type: Object,
      default: () => ({})
    },
    // 选中的事件
    picthOnEvent: {
      type: Object,
      default: () => { }
    },
    // 对事件的几种操作
    EventMotion: {
      type: [String, Number],
      default: 0
    }, // 0 展示 1编辑 2创建
    // R的信息
    fixedDevice: Object,
    // 鼠标所点位置
    BoxPosition: {
      type: Object,
      default: () => ({
        top: 500,
        left: 500,
        bottom: 500,
        right: 500
      })
    }
  },
  data () {
    return {
      // 对事件的几种操作
      EventMotionSelect: 0,
      // 弹出框的一些属性
      FrameProperty: {
        height: '400px',
        left: 100,
        top: 200
      },
      // 事件的详细信息
      eventDetail: {
        title: '',
        color: 'rgb(15, 190, 113)',
        delay: 2,
        bitrate: 5120
      },
      //  是note还是device
      CompileType: 'note',
      // 一系列开关
      mostSwitch: {
        // 颜色开关
        ColorShow: false,
        // 选择Source
        BoxSourceList: false,
        // 编辑Delay 延时时间
        editDelay: false,
        // 编辑bit率
        editBit: false
      },
      //   颜色选项
      colorArr: [
        {
          name: 'green',
          value: 'rgb(15, 190, 113)'
        },
        {
          name: 'skyblue',
          value: 'rgb(70, 201, 225)'
        },
        {
          name: 'blue',
          value: 'rgb(14,107,209)'
        },
        {
          name: 'orange',
          value: 'rgb(255, 197, 115)'
        },
        {
          name: 'pink',
          value: 'rgb(255, 106, 146)'
        },
        {
          name: 'yellow',
          value: 'rgb(255, 192, 0)'
        },
        {
          name: 'purple',
          value: 'rgb(146, 72, 199)'
        }
      ],
      // 时间选择
      TimeSelect: [],
      // 时间差
      timeDifference: 16 * 60 * 60 * 1000,
      // Source查询列表
      SourceList: [],
      // Source查询分页
      SourcePaging: {
        SourcepageNum: 0,
        loadEnd: false
      }
    }
  },
  components: {
  },
  watch: {
    CompileType () {
      // 设置弹出框高度
      this.SetFrameHeight()
    }
  },
  created () {
    this.EventMotionSelect = this.EventMotion
    // 设置弹出框高度
    this.SetFrameHeight()
    // 判断是查看还是编辑
    this.estimateOperate()
    // 获取source列表
    this.getSourceList()
  },
  mounted () { },
  methods: {
    // 获取source列表
    getSourceList () {
      this.SourcePaging.SourcepageNum++
      if (!this.SourcePaging.loadEnd) {
        this.axios
          .post(utils.getUrl(`/event/listSource/${this.$BehaviorSyns.getProgramId()}`), {
            bookmardIds: 'all',
            unClassified: true,
            pack: true,
            anywhere: true,
            gridPack: true,
            gridSdi: true,
            ext: true,
            token: true,
            scte: true,
            pageNum: this.SourcePaging.SourcepageNum,
            pageSize: 35
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data.errorCode == '0x0') {
                const { result } = res.data
                if (result.deviceList.result) {
                  this.SourceList.push(...result.deviceList.result.list)
                }
                if (result.deviceList.result.list.length < 35) {
                  this.SourcePaging.loadEnd = true
                }
              } else {
                const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
                this.$message.error(errorInfo)
              }
            }
          })
      }
    },
    // 选择source
    SelectSource (item) {
      // if (!this.eventDetail.title) {
      this.eventDetail.title = item.name
      // }

      this.eventDetail.tname = item.name
      this.eventDetail.tpeerid = item.peerId
      this.eventDetail.ttype = item.type
    },
    // 选中时间
    UpdateTime (time) {
      this.eventDetail.startTime = time[0].getTime() - this.timeDifference
      this.eventDetail.endTime = time[1].getTime() - this.timeDifference
    },
    // 选择颜色
    chooseColor (item) {
      this.eventDetail.color = item.value
      this.mostSwitch.ColorShow = false
    },
    // 复制事件
    copyEvent () { },
    // 取消 保存 删除 创建
    AllOperation (method) {
      if (!this.eventDetail.tpeerid) {
        this.eventDetail.color = 'rgb(255, 255, 255)'
      }
      console.log(this.eventDetail)
      this.$emit(method, this.eventDetail)
    },
    // 转换颜色
    ColorTransition (color) {
      const colorName = this.colorArr.filter((item) => item.value == color)
      return colorName[0] ? colorName[0].name : 'purple'
    },
    // 设置框的高度
    SetFrameHeight () {
      if (this.EventMotion == 0) {
        this.FrameProperty.height = '290px'
      }
      if (this.CompileType == 'note') {
        this.FrameProperty.height = '290px'
      } else {
        this.FrameProperty.height = '290px'
      }
      if (this.BoxPosition.bottom >= 300 && this.BoxPosition.right >= 400) {
        this.FrameProperty.top = this.BoxPosition.top
        this.FrameProperty.left = this.BoxPosition.left
      } else if (
        this.BoxPosition.bottom < 300 &&
        this.BoxPosition.right >= 400
      ) {
        this.FrameProperty.top = this.BoxPosition.top - 290
        this.FrameProperty.left = this.BoxPosition.left
      } else if (
        this.BoxPosition.bottom >= 300 &&
        this.BoxPosition.right < 400
      ) {
        this.FrameProperty.top = this.BoxPosition.top
        this.FrameProperty.left = this.BoxPosition.left - 400
      } else {
        this.FrameProperty.top = this.BoxPosition.top - 290
        this.FrameProperty.left = this.BoxPosition.left - 400
      }
      this.FrameProperty.top = `${this.FrameProperty.top}px`
      this.FrameProperty.left = `${this.FrameProperty.left}px`
    },
    // 判断是查看还是编辑
    estimateOperate () {
      this.eventDetail = JSON.parse(JSON.stringify(this.picthOnEvent))
      this.eventDetail.time =
        `${this.millisecondTime(this.eventDetail.startTime)
        }-${
        this.millisecondTime(this.eventDetail.endTime)}`
      this.eventDetail.rname = this.fixedDevice.name
      this.TimeSelect = [
        new Date(this.eventDetail.startTime + this.timeDifference),
        new Date(this.eventDetail.endTime + this.timeDifference)
      ]
    },
    // 毫秒数转换成时分秒
    millisecondTime (time) {
      let hour,
        minute,
        second
      // day = Math.floor(time / (24 * 60 * 60 * 1000));
      hour = Math.floor((time % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
      minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
      second = Math.floor((time % (60 * 1000)) / 1000)
      hour = String(hour).length == 1 ? `0${hour}` : hour
      minute = String(minute).length == 1 ? `0${minute}` : minute
      second = String(second).length == 1 ? `0${second}` : second
      return `${hour}:${minute}:${second}`
    }
  }
}
</script>

<style scoped lang="less">
.TemplatePop {
  // position: fixed;
  // top: 0;
  // left: 0;
  .createBooking {
    position: fixed;
    width: 4rem;
    height: 3rem;
    background-color: #252525;
    border-radius: 4px;
    z-index: 2000;
    padding: 0.16rem;
    padding-right: 0.2rem;
    color: #999;
    font-size: 0.16rem;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.78);
  }
  .EventWrapTtile {
    margin-bottom: 15px;
    .closeCreateBox {
      position: absolute;
      right: 20px;
      top: 15px;
    }
    .Event_title {
      width: 340px;
      height: 20px;
      text-align: left;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .CompileTitle {
      display: flex;
    }
    .separator {
      padding: 0 10px;
    }
    li.active {
      color: #33ab4f;
    }
    .event_color {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      border: none;
    }
  }
  .EventDetail {
    font-size: 12px;
    .detail_item {
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(153, 153, 153, 1);
      padding: 0 10px;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .detailLeft {
        font-size: 12px;
        color: #666;
        margin: 0;
      }
      .detailRight {
        color: #999;
        width: 150px;
        margin: 0;
        text-align: left;
      }
      /deep/.el-input__inner {
        border: none;
        color: #999;
        font-size: 12px;
        width: 165px;
      }
    }
    margin-bottom: 10px;
  }
  .EventUpdateandCreate {
    .note {
      .color_box {
        height: 100%;
        padding-right: 22px;
        position: relative;
      }
      .color_opt {
        width: 255px;
        height: 40px;
        background: #333;
        color: #999;
        border-radius: 4px;
        position: absolute;
        right: -11px;
        top: 31px;
        padding: 10px 0;
        padding-left: 6px;
        font-size: 12px;
        line-height: 20px;
        z-index: 10000;
        display: flex;
        ul {
          display: flex;
          li {
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-left: 10px;
          }
        }
      }
      .color {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        margin-top: 4px;
        box-sizing: content-box;
      }
      .el-icon-caret-bottom {
        font-size: 20px;
        position: absolute;
        top: 16%;
        right: 0px;
        transform: translateY(-50%);
        transform: rotate(0deg);
        transition: 0.3s;
      }
      .el-icon-caret-bottom.top {
        transform: rotate(-180deg);
      }
      .to {
        color: #999;
        margin-left: 7px;
        line-height: 30px;
        font-size: 12px;
      }
      textarea {
        width: 364px;
        border: none;
        outline: none;
        background: #444;
        border-radius: 4px;
        height: 60px;
        color: #999;
        font-size: 12px;
        line-height: 15.6px;
        padding: 2px 2px 2px 10px;
        box-sizing: border-box;
      }
      .c_item {
        display: flex;
        margin-bottom: 10px;
        input {
          width: 364px;
          height: 30px;
          background-color: #444;
          color: #999;
          border: none;
          outline: none;
          border-radius: 4px;
          text-indent: 10px;
          font-size: 12px;
          box-sizing: border-box;
          text-align: left;
        }
        .time_opt {
          width: 170px;
          height: 30px;
          line-height: 26px;
          color: #000;
          background: rgba(228, 228, 228, 1);
          border: none;
          border-radius: 4px;
          /deep/.el-date-editor.el-input,
          .el-date-editor.el-input__inner {
            width: 100%;
          }
          /deep/input.el-input__inner {
            width: 100%;
            background: #444;
            padding: 0;
            border: none;
          }
          /deep/.el-input__prefix,
          .el-input__suffix-inner {
            display: none;
          }
        }
        /deep/.el-input__inner {
          width: 365px;
          border: none;
          height: 30px;
          padding: 0;
          .el-input__icon {
            display: none;
          }
          input::-webkit-input-placeholder {
            color: #999;
            font-size: 12px;
            text-align: left;
          }
          .el-range-separator {
            color: #999;
            margin-left: 7px;
            margin-right: 7px;
            line-height: 30px;
            font-size: 12px;
          }
          .el-range-input {
            width: 165px;
            text-align: left;
            color: #999;
            background-color: #444;
            padding-left: 7px;
          }
        }
        /deep/.el-scrollbar__bar.is-vertical {
          display: none;
        }
      }
    }

    .device {
      color: rgb(102, 102, 102);
      margin: 0 9px;
      .d_item {
        width: 100%;
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        font-size: 12px;
        padding: 0 20px 0 10px;
        display: flex;
        justify-content: space-between;
        .val {
          color: #999;
          width: 56%;
          text-align: right;
          position: relative;
        }
        .ValSelet {
          padding-right: 10px;
          span {
            height: 31px;
            overflow: hidden;
          }
        }
        .ValSelet::before {
          content: '';
          position: absolute;
          top: 60%;
          left: 94%;
          border: 6px solid;
          transform: translateY(-50%);
          border-color: transparent;
          border-top-color: #999;
          transition: 0.3s;
        }
        .ValSelet.up:before {
          top: 23%;
          transform: rotate(-180deg);
        }
        .input {
          float: right;
          height: 25px;
          width: 135px;
          margin-top: 3px;
          margin-right: -20px;
          border: none;
          padding-left: 10px;
          padding-right: 20px;
          box-sizing: border-box;
          color: #999;
          background-color: transparent;
          text-align: right;
          outline: none;
        }
        .scte_ipt {
          color: #000;
        }
        .delay,
        .bitrate {
          text-align: left;
          background-color: #fff;
        }
        /deep/ .createbox_r_list {
          position: absolute;
          right: 0;
          top: 32px;
          background: #ababab;
          width: 2.2rem;
          height: 170px;
          text-align: left;
          .infinite-list {
            height: 170px;
          }
          li {
            padding-left: 10px;
            height: 32px;
            line-height: 32px;
            box-sizing: border-box;
            font-size: 12px;
            color: #666;
          }
          li:hover {
            background: rgba(0, 208, 105, 0.2);
          }
          .el-scrollbar__thumb {
            background: #fff;
          }
        }
      }
      .d_item.source {
        input {
          float: right;
          border: none;
          height: 25px;
          width: 100px;
          padding-left: 10px;
          padding-right: 25px;
          margin-right: -20px;
          margin-top: 3px;
          box-sizing: content-box;
          color: #000;
        }
      }
    }
  }

  .create_footer {
    margin-top: 20px;
    button {
      width: 86px;
      height: 30px;
      background: #999;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 12px;
    }
    .ComplieButton {
      display: flex;
      justify-content: flex-end;
    }
    .save,
    .edit {
      background-color: #0c6;
      margin-left: 10px;
    }
    .delete {
      width: 72px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid rgba(153, 153, 153, 1);
      background: transparent;
    }
    .copy {
      margin-left: 100px;
      color: #39aa50;
      border: 1px solid #39aa50;
      background: transparent;
    }
    .end_live {
      background: #f00;
      color: #fff;
    }
  }
  .green {
    border: 1px solid #0a9a5a;
    background: #0fbe71;
  }
  .skyblue {
    background-color: #46c9e1;
    border: 1px solid #0ca595;
  }
  .blue {
    background-color: #2f8df4;
    border: 1px solid #126ed3;
  }
  .orange {
    background-color: #ffc573;
    border: 1px solid #d8a966;
  }
  .pink {
    background-color: #ff6a92;
    border: 1px solid #ee3656;
  }
  .yellow {
    background-color: #ffc000;
    border: 1px solid #ffc000;
  }
  .purple {
    background-color: #9248c7;
    border: 1px solid #9248c7;
  }
}
// /deep/ .create_booking.triangle:before {
//   border-top-color: #dcdcdc;
//   border-right-color: #dcdcdc;
//   border-bottom-color: transparent;
//   left: 0.6rem;
//   top: -0.095rem;
//   border-width: 12px;
//   box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
//   transform: rotate(-45deg);
// }
// /deep/ .create_booking.right.triangle:before {
//   left: 3.4rem;
// }
// /deep/ .create_booking.bottom.triangle:before {
//   top: 3.05rem;
//   transform: rotate(135deg);
// }
// /deep/ .create_booking.bottom.device.triangle:before {
//   top: 2.46rem;
// }
</style>
